import {DashboardCard} from '../dashboard-card/DashboardCard'
import {Text} from '@/components/ui/text/Text'
import {useGetDashboardOps} from '../../query/useGetDashboardOps'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {DashboardSearchParams} from '../../types'
import {DashboardSimpleCardSkeleton} from '../dashboard-simple-card-skeleton/DashboardSimpleCardSkeleton'
import {formatNumber} from '@/utilities/helpers'

export const DashboardAccreditationPatientsCard = () => {
    const {searchParams} = useParsedSearchParams(DashboardSearchParams)
    const {data, isLoading} = useGetDashboardOps({
        fields: ['patients'],
        ...searchParams
    })

    if (isLoading) {
        return <DashboardSimpleCardSkeleton title="Pazienti in accreditamento" />
    }

    return (
        <DashboardCard title="Pazienti in accreditamento">
            <Text palette="neutral" shade="900" size="displaySm" weight={700}>
                {formatNumber(data?.patients ?? 0)}
            </Text>
        </DashboardCard>
    )
}
